import BaseLayer from "./BaseLayer";
import {plotDisagreementv2Unit} from "../utils/map_utils";

class StitchDisagreementv2 extends BaseLayer {

    id = "stitchDisagreementv2";
    label = "Final Disagreement";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchDisagreement, textColor} = this.props;
        stitchDisagreement = stitchDisagreement.result;
        const margin = 3 / 10;
        const sizeOfMarker = 0.2;
        let disagreementL2NormMax = 0;
        let disagreementL2NormMin = 100000000; // some large number
        for (const key in stitchDisagreement) {
            const disagreement = stitchDisagreement[key];
            const bothComputedDeltaZero = disagreement["computedTop"]["tx"] === 0 &&
                disagreement["computedTop"]["ty"] === 0;
            if (disagreement["noActualTopTxTy"] !== undefined && disagreement["noActualTopTxTy"] === false
                && !bothComputedDeltaZero) {
                const disagreementTop = disagreement["disagreementTop"];
                const deltaTxSq = disagreementTop["deltaTx"] * disagreementTop["deltaTx"];
                const deltaTySq = disagreementTop["deltaTy"] * disagreementTop["deltaTy"];
                const l2norm = Math.sqrt(deltaTxSq + deltaTySq);
                if (l2norm < 1000 && l2norm > disagreementL2NormMax)
                    disagreementL2NormMax = l2norm;
                if (l2norm < 1000 && l2norm < disagreementL2NormMin)
                    disagreementL2NormMin = l2norm;
            }
            const bothComputedDeltaZero2 = disagreement["computedLeft"]["tx"] === 0
                && disagreement["computedLeft"]["ty"] === 0;
            if (disagreement["noActualLeftTxTy"] !== undefined && disagreement["noActualLeftTxTy"] === false
                && !bothComputedDeltaZero2) {
                const disagreementLeft = disagreement["disagreementLeft"];
                const deltaTxSq = disagreementLeft["deltaTx"] * disagreementLeft["deltaTx"];
                const deltaTySq = disagreementLeft["deltaTy"] * disagreementLeft["deltaTy"];
                const l2norm = Math.sqrt(deltaTxSq + deltaTySq);
                if (l2norm < 1000 && l2norm > disagreementL2NormMax)
                    disagreementL2NormMax = l2norm;
                if (l2norm < 1000 && l2norm < disagreementL2NormMin)
                    disagreementL2NormMin = l2norm;
            }
        }

        for (const key in stitchDisagreement) {
            // sample key is "x9y32.jpg"
            const xHori = parseInt(key.split('y')[0].split('x')[1]);
            const yVerti = parseInt(key.split('y')[1].split('.' + this.props.slide.img_type)[0]);
            const disagreement = stitchDisagreement[key];
            plotDisagreementv2Unit(disagreement, disagreementL2NormMax, disagreementL2NormMin,
                this.props.slide, xHori, yVerti, margin, sizeOfMarker, this.layer.getSource(), textColor);
        }
        resolve();
    });
}

export default StitchDisagreementv2;
